import { Route, Routes } from 'react-router-dom';
import DeviceAccounting from './DeviceAccounting';
import PartDbMatching from './PartDbMatching';
import PartDbReceiving from './PartDbReceiving';

const DeviceAccountingRouter = () => {
    return (
        <Routes>
            <Route path="/part-db/matching" element={<PartDbMatching />} />
            <Route path="/part-db/receiving/:project_id/:quantity" element={<PartDbReceiving />} />
            <Route path="/" element={<DeviceAccounting />} />
        </Routes>
    );
};

export default DeviceAccountingRouter;
